export interface AccountManager {
  name: string;
  email: string;
}

export const getDefaultAccountManager = (email: string): AccountManager =>
  ({
    name: 'Customer Service Team',
    email,
  }) as const;
